<div class="d-grid gap-3" style="grid-template-columns: 350px 1fr" *ngIf="viewType !== 'table'">
  <app-automation-wizard-left
    [type]="type"
    (typeChange)="typeChange.emit($event)"
    image="/assets/images/automation-wizards/guest.webp"
  >
    <p i18n>
      The Guest Entity represents individuals who have engaged with a property through inquiries, bookings, or direct
      interactions. This entity stores guest information, including contact details and other relevant data.
    </p>
    <p i18n>
      Automating guest-related actions will streamline communication, improve response times, and enhance the overall
      guest experience within the Unified Inbox.
    </p>
  </app-automation-wizard-left>
  <div class="card shadow">
    <div class="card-header flex-column align-items-start p-3 bg-default2">
      <h6 i18n>What would you like to do when a guest is</h6>
      <div class="btn-group">
        <button
          type="button"
          (click)="onSelectEvent(events.GuestCreated)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.GuestCreated ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Created
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.GuestUpdated)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.GuestUpdated ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Edited
        </button>
      </div>
    </div>
    <div class="card-body d-flex flex-column gap-3">
      <ng-container [ngSwitch]="selectedEvent">
        <ng-template *ngSwitchCase="events.GuestCreated" [ngTemplateOutlet]="createdEvent"></ng-template>
        <ng-template *ngSwitchCase="events.GuestUpdated" [ngTemplateOutlet]="updatedEvent"></ng-template>
      </ng-container>
      <div class="flex-fill"></div>
    </div>
  </div>
</div>

<div *ngIf="viewType === 'table'" class="d-flex flex-column gap-4 automation-table">
  <div class="table-view-header text-muted text-semi-bold">
    <div class="text-uppercase text-muted mb-0" i18n>What would you like to do when</div>
    <div i18n>Created Date • Time</div>
    <div i18n>Last Triggered Date • Time</div>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Guest is Created</h6>
    <ng-template [ngTemplateOutlet]="createdEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Guest is Updated</h6>
    <ng-template [ngTemplateOutlet]="updatedEvent"></ng-template>
  </div>
</div>

<ng-template #createdEvent>
  <app-do-action-automation
    [event]="events.GuestCreated"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.GuestWhatsappWelcomeHandler"
    templateId="HX636c6737d143cfc4e57c878a138e9165"
    i18n-label
    label="Send a predefined generic WhatsApp message to initiate a conversation."
  ></app-do-action-automation>
  <app-notify-users-automation
    [event]="events.GuestCreated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Notify user(s) of the new guest entry."
    [messageSubject]="userNotificationMessages[events.GuestCreated].subject"
    [messageBody]="userNotificationMessages[events.GuestCreated].message"
  ></app-notify-users-automation>
</ng-template>

<ng-template #updatedEvent>
  <app-notify-users-automation
    [event]="events.GuestUpdated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Notify user(s) of any updates to the guest profile."
    [messageSubject]="userNotificationMessages[events.GuestUpdated].subject"
    [messageBody]="userNotificationMessages[events.GuestUpdated].message"
  ></app-notify-users-automation>
</ng-template>
